import React from "react";
import Accessory from "../components/accessory";
export default (props) => {
    return (React.createElement("div", { "data-ecom-page": "" },
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, "Tillbeh\u00F6r"),
            React.createElement("div", { "data-ecom-content": "" },
                React.createElement("p", null, "Vill du utrusta din nya bil med n\u00E5got extra? Nedan listas ett urval av tillbeh\u00F6r som passar till din bil."))),
        React.createElement("section", { className: "page-section page-section-accent" }, props.orderOptions
            .getAccessories()
            .slice(0, 5)
            .map((accesory) => (React.createElement(Accessory, Object.assign({ accessory: accesory, key: accesory.id }, props))))),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { className: "repeat-m" },
                React.createElement("button", { "data-ecom-button": "full-width", onClick: props.onProceedToNextStep }, "G\u00E5 vidare")),
            React.createElement("div", { className: "repeat-m" },
                React.createElement("button", { "data-ecom-button": "full-width light", onClick: props.onProceedToNextStep }, "Hoppa \u00F6ver detta steg")))));
};
